import lottie from 'lottie-web/build/player/lottie_light';

function LottieAnimation({ node }) {
	lottie.loadAnimation({
		container: node, // the dom element that will contain the animation
		renderer: 'svg',
		loop: true,
		autoplay: true,
		path: 'dist/animations/data.json', // the path to the animation json
	});
}

export default LottieAnimation;
